function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
var prefixCls = 'eui-input';
var DEFAULT_PLACEHOLDER_STRING = '请输入';

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input() {
    var _this;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "textInput", null);

    _defineProperty(_assertThisInitialized(_this), "focusTextInput", function () {
      // Focus the text input using the raw DOM API
      if (_this.textInput) _this.textInput.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "formatValue", function (value) {
      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "primitiveValue", function (value) {
      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "handleValueChange", function (e, eventName) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus;

      var targetVal = _this.primitiveValue(e.target.value);

      if (eventName === 'onChange') {
        onChange(targetVal);
      } else if (eventName === 'onBlur') {
        onBlur(targetVal);
      } else if (eventName === 'onFocus') {
        onFocus(targetVal);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.handleValueChange(e, 'onChange');
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      _this.handleValueChange(e, 'onFocus');
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      _this.handleValueChange(e, 'onBlur');
    });

    return _this;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // this.focusTextInput();
      var onEnterClick = this.props.onEnterClick;

      if (typeof onEnterClick === 'function') {
        var submitEvent = function submitEvent(event) {
          // Number 13 is the "Enter" key on the keyboard
          if (event.keyCode === 13) {
            // Cancel the default action, if needed
            event.preventDefault(); // Trigger the button element with a click

            var targetVal = _this2.primitiveValue(event.target.value);

            onEnterClick(targetVal, event); // this.textInput.removeEventListener('keyup', submitEvent);
          }
        };

        this.textInput.addEventListener('keyup', submitEvent);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          disabled = _this$props2.disabled,
          size = _this$props2.size,
          value = _this$props2.value,
          error = _this$props2.error,
          suffix = _this$props2.suffix,
          onEnterClick = _this$props2.onEnterClick,
          other = _objectWithoutProperties(_this$props2, ["children", "className", "placeholder", "disabled", "size", "value", "error", "suffix", "onEnterClick"]);

      var classes = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "--").concat(size), size !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "--withsuffix"), suffix), _defineProperty(_classNames, "error", error), _defineProperty(_classNames, "disabled", disabled), _classNames), className);
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("input", _extends({
        className: "".concat(prefixCls, "-original"),
        placeholder: placeholder,
        value: this.formatValue(value),
        ref: function ref(el) {
          _this3.textInput = el;
        },
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        disabled: disabled
      }, other)), suffix);
    }
  }]);

  return Input;
}(React.Component);

_defineProperty(Input, "defaultProps", {
  placeholder: DEFAULT_PLACEHOLDER_STRING,
  size: 'medium',
  disabled: false,
  error: false,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onEnterClick: function onEnterClick() {},
  value: undefined
});

_defineProperty(Input, "propTypes", {
  // 是否不可输入
  disabled: PropTypes.bool,
  // 是否提示错误
  error: PropTypes.bool,
  // 尺寸
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /** 变更回调 */
  onChange: PropTypes.func,

  /** focus 回调 */
  onFocus: PropTypes.func,

  /** blur 回调 */
  onBlur: PropTypes.func,

  /** 回车键 回调 */
  onEnterClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  // input placeholder
  placeholder: PropTypes.string,
  // 文本值
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});

export default Input;